var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("OverlayLayout", [
    _c(
      "div",
      {
        staticClass:
          "relative h-full w-full flex flex-col pb-ogs-large md:pb-10",
      },
      [
        _c(
          "div",
          { staticClass: "flex-1 px-ogs-large mb-5 md:mb-10 relative z-20" },
          [
            _c("div", { staticClass: "h-full flex flex-col" }, [
              _c("div", { staticClass: "flex-1 py-5 md:py-10" }, [
                _c(
                  "div",
                  { staticClass: "h-full relative" },
                  [
                    _vm._l(_vm.palettes, function (palette, index) {
                      return [
                        _vm._l(palette.colours, function (item, index) {
                          return [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.id === _vm.displayColour.id,
                                  expression: "item.id === displayColour.id",
                                },
                              ],
                              staticClass:
                                "absolute inset-0 w-full h-full object-contain rounded-full",
                              attrs: { src: item.image[0].url },
                            }),
                          ]
                        }),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "grid grid-cols-12 gap-x-gs" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "md:col-start-5 col-span-12 md:col-span-4 flex flex-col items-center justify-end",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn-soft",
                        on: { click: _vm.handleSelectColour },
                      },
                      [
                        _vm._v(
                          "\n              Shop " +
                            _vm._s(_vm.displayColour.title) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "hidden md:flex col-span-2 md:col-span-4 items-end justify-end",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "block w-8 h-8 focus:outline-none mr-2 transition duration-300",
                        class: {
                          "opacity-0": !_vm.showPrevSlideButton,
                          "opacity-100": _vm.showPrevSlideButton,
                        },
                        on: {
                          click: function ($event) {
                            _vm.triggerPrevSlide++
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass:
                              "w-full h-full transition duration-300",
                            attrs: {
                              viewBox: "0 0 30 30",
                              fill: "var(--theme)",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Zm0,29A14,14,0,1,0,1,15,14,14,0,0,0,15,29ZM10.15,14.38l6.15,6.79L17,20.5l-5.52-6.1L17,8.68,16.31,8Z",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content: "Discover more",
                              offset: 5,
                              placement: "left",
                              classes:
                                "tooltip--simple-theme hidden! md:block!",
                              hideOnTargetClick: false,
                            },
                            expression:
                              "{\n                content: 'Discover more',\n                offset: 5,\n                placement: 'left',\n                classes: 'tooltip--simple-theme hidden! md:block!',\n                hideOnTargetClick: false,\n              }",
                          },
                        ],
                        staticClass: "block w-8 h-8 focus:outline-none",
                        on: {
                          click: function ($event) {
                            _vm.triggerNextSlide++
                          },
                          mouseover: function ($event) {
                            _vm.showPrevSlideButton = false
                          },
                          mouseout: function ($event) {
                            _vm.showPrevSlideButton = true
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass:
                              "w-full h-full transition duration-300",
                            attrs: {
                              viewBox: "0 0 30 30",
                              fill: "var(--theme)",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M15,30A15,15,0,1,1,30,15,15,15,0,0,1,15,30ZM15,1A14,14,0,1,0,29,15,14,14,0,0,0,15,1Zm4.85,14.62L13.7,8.83,13,9.5l5.52,6.1L13,21.32l.72.69Z",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "relative flex-shrink-0 z-20" },
          [
            _c("ColourSelectorSlider", {
              attrs: {
                palettes: _vm.palettes,
                "selected-colour": _vm.displayColour,
                "is-mobile": _vm.isMobile,
                "is-coating-product": "",
                "trigger-next-slide": _vm.triggerNextSlide,
                "trigger-prev-slide": _vm.triggerPrevSlide,
              },
              on: {
                "change-colour": _vm.handleChangeColour,
                "select-colour": _vm.handleSelectColour,
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }